var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-banner",style:(("background: url('" + _vm.banner + "')"))},[_c('div',{staticClass:"product-slogan"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"product-slogan-description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661d7f0b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productBanner.vue
// module id = null
// module chunks = 